import { render, staticRenderFns } from "./health_care.vue?vue&type=template&id=449f935a&scoped=true"
import script from "./health_care.vue?vue&type=script&lang=js"
export * from "./health_care.vue?vue&type=script&lang=js"
import style0 from "./health_care.vue?vue&type=style&index=0&id=449f935a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f935a",
  null
  
)

export default component.exports